"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpCollapse = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_bootstrap_1 = require("react-bootstrap");
var DpCollapse_styled_1 = require("./DpCollapse.styled");
var Icon_1 = __importDefault(require("../Icon/Icon"));
/**
 * DpCollapse
 *
 * @property {ReactNode}      headerContent   - Content header
 * @property {ReactNode}      children        - Content body
 * @property {string}         icon            - Button icon
 * @property {boolean}        expanded        - Shows the content
 * @property {string}         iconAriaLabel   - aria label for the icon that open and close the accordion
 */
var DpCollapse = function (_a) {
    var headerContent = _a.headerContent, children = _a.children, _b = _a.icon, icon = _b === void 0 ? 'arrow-drop' : _b, _c = _a.expanded, expanded = _c === void 0 ? true : _c, onExpansion = _a.onExpansion, iconAriaLabel = _a.iconAriaLabel, identifier = _a.identifier;
    var _d = (0, react_1.useState)(expanded), open = _d[0], setOpen = _d[1];
    var getIconName = function (flag) {
        return (flag ? "".concat(icon, "-up") : "".concat(icon, "-down"));
    };
    (0, react_1.useEffect)(function () {
        setOpen(expanded);
    }, [expanded]);
    var toggle = function () { return setOpen(!open); };
    var handleClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(!open && onExpansion !== undefined)) return [3 /*break*/, 2];
                    return [4 /*yield*/, onExpansion(true)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    toggle();
                    return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)(DpCollapse_styled_1.StyledContainer, { className: "border-bottom", children: [(0, jsx_runtime_1.jsxs)("div", { tabIndex: 0, className: "collapse-header ".concat(open ? 'open' : ''), children: [headerContent, (0, jsx_runtime_1.jsx)(react_bootstrap_1.Button, { onClick: handleClick, "aria-controls": "collapse-".concat(identifier), "aria-expanded": open, className: "expand-collapse-btn", "aria-label": iconAriaLabel, children: (0, jsx_runtime_1.jsx)(Icon_1.default, { name: getIconName(open) }) })] }), open && ((0, jsx_runtime_1.jsx)(react_bootstrap_1.Collapse, { in: open, children: (0, jsx_runtime_1.jsx)("div", { id: "collapse-".concat(identifier), children: children }) }))] }));
};
exports.DpCollapse = DpCollapse;
exports.default = exports.DpCollapse;
